import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { KundeTokenService } from '@comparit/infrastructure';
import { FunnelLoginService } from '../../../services/funnel-login.service';

@Component({
  selector: 'app-mlp-login-banner',
  imports: [MatButtonModule],
  templateUrl: './mlp-login-banner.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MlpLoginBannerComponent {
  private readonly kundeLogin = inject(FunnelLoginService);
  private readonly kundeToken = inject(KundeTokenService);
  protected readonly isLoggedIn = this.kundeToken.isLoggedIn;
  protected readonly windowMode = this.kundeToken.windowMode;

  protected login(): void {
    this.kundeLogin.openLogin();
  }
}
